<template>
  <div class="header_block">
    <div class="header_base">
      <div class="header">
        <!-- <SpMenu class="sp-menu" :currentUser="currentUser" :menuMode="showMenu" @change_menu="toggleMenu">
        </SpMenu> -->
        <img v-if="i18n_mode == 'jp' && $route.name != 'PackDetail' && $route.name != 'GetCardList' && $route.name != 'ConfirmGetCardList'" class="logo" src="/img/logo_pc.png?g=20240524" @click="page('/')">
        <div class="return-list" v-if="$route.name == 'PackDetail'" @click="$router.push('/')"><i class="fa fa-angle-double-left arrow"></i>ガチャ一覧</div>
        <div class="get-list" v-if="$route.name == 'GetCardList' || $route.name == 'ConfirmGetCardList'">発送商品を選択</div>
        <div class="login_area lrwidth">
          <div class="get-skip" v-if="$route.name == 'GetCardList' || $route.name == 'ConfirmGetCardList'" @click="shippingSkip">発送をスキップ<i class="fa fa-angle-double-right arrow"></i></div>
          <div class="login" :class="{'get-list-mobile': $route.name == 'GetCardList' || $route.name == 'ConfirmGetCardList'}">
            <!-- <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon_sp" @click="toggleMenu(!showMenu)">
            <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="toggleMenu(!showMenu)"> -->
            <span v-if="currentUser.is_login == '0'" class="login_box">
              <a @click="page('/login')">ログイン/新規登録</a>
            </span>
            <img v-if="currentUser.is_login != '0'" src="/img/icons/coin.png" class="point_icon">
            <span v-if="currentUser.is_login != '0'" class="point_block" @click="page('/buy-point')">
              <number>{{ currentUser.point | comma }}</number>
              <div class="plus"></div>
            </span>
            <img v-if="currentUser.is_login != '0'" src="/img/account.png" class="account" @click="toggleMenu(!showMenu)">
          </div>
        </div>
      </div>
      <!-- <div v-if="showMenu" class="menu_area">
        <div v-if="currentUser.is_login == '1'" class="user_area sp">
          <div class="user_name">{{ currentUser.last_name }} {{ currentUser.first_name }}さん</div>
          <div class="point_area">
            {{ currentUser.point | comma }}
          </div>
          <div class="coin_area">
            {{currentUser.coin | commaDecimal}}
          </div>
        </div>
        <div class="menu" @click="page('/my-page')">マイページ</div>
        <div class="menu" @click="page('/buy-point')">ポイント購入</div>
        <div class="menu" @click="page('/buy-point-history')">ポイント履歴</div>
        <div class="menu" @click="page('/buy-product-history')">商品購入履歴</div>
        <div class="menu" @click="page('/exchange-card')">引換所</div>
        <div class="menu" @click="page('/user-guide')">ご利用ガイド</div>
        <div class="menu sp" @click="toiawase()">お問い合わせ</div>
        <div class="menu" @click="page('/terms-of-service')">利用規約</div>
        <div class="logout" @click="logout()" v-if="currentUser.is_login == '1'">
          <span>ログアウト<img src="/img/logout_icon.png"></span>
        </div>
        <div class="logout" @click="page('/login')" v-if="currentUser.is_login == '0'"><span>ログイン</span></div>
      </div> -->

      <div class="menu-overlay" :class="{ active: showMenu }" @click="toggleMenu(!showMenu)"></div>
      <div class="menu" :class="{ active: showMenu }">
        <div class="close-button" @click="toggleMenu(!showMenu)">×</div>
        <h2>マイページ</h2>
        <ul>
          <li>
            <MenuTitle title="所有者ポイント" image="/img/point.png"></MenuTitle>
            <div class="menu-point">
              <div class="charge" @click="page('/buy-point')">
                <span><div class="charge_plus"></div>チャージ</span>
              </div>
              <div class="login_area lrwidth">
                <div class="login">
                  <span v-if="currentUser.is_login == '0'" class="login_box">
                    <a @click="page('/login')">ログイン/新規登録</a>
                  </span>
                  <img v-if="currentUser.is_login != '0'" src="/img/icons/coin.png" class="pc point_icon">
                  <span v-if="currentUser.is_login != '0'" class="point_block" @click="page('/buy-point')">
                    <number>{{ currentUser.point | comma }}</number>
                    <div class="plus"></div>
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <MenuTitle title="クーポンを利用" image="/img/present.png"></MenuTitle>
            <div class="menu-point">
              <input type="text" v-model="couponCode" maxlength="20" placeholder="クーポンコードを入力してください。" />
              <div class="button-append" @click="useCoupon">適用</div>
            </div>
            <div v-if="couponCodeError" class="menu-point error-message">{{ couponCodeError }}</div>
            <div class="menu-comment">
              ※適用中のクーポンがある場合、新しいクーポンが上書きされます。<br>
              古いクーポンは無効となりますのでご注意ください。
            </div>
          </li>
          <RankArea :currentUser="currentUser"></RankArea>
          <li>
            <MenuTitle title="現在の発送先住所" image="/img/home.png"></MenuTitle>
            <div class="manu-address">
              <div class="name">{{ lastName }}{{ middleName }}{{ firstName }}</div>
              <div v-if="zipCode">
                <div class="post-address">〒{{ zipCode }}</div>
                <!-- <div class="address">東京都千代田区1-1-1</div> -->
                <div class="address">{{ prefectureName }}{{ shiku }}{{ address }}{{ building }}</div>
              </div>
              <div v-else>
                <div class="post-address">
                  <div class="charge add_address" @click="showSaveAddress">
                    <span>住所登録</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <MenuTitle
              title="オリパ購入履歴"
              image="/img/card.png"
              @click="page('/buy-product-history')"
            />
          </li>
          <li>
            <MenuTitle
              title="LINE友達追加(毎日抽選2,000ptチャンス)"
              image="/img/card.png"
              @click="page('https://lin.ee/xHQJDyW', true)"
            />
          </li>
          <li>
            <MenuTitle
              title="Xフォロー(プレゼントキャンペーン)"
              image="/img/card.png"
              @click="page('https://x.com/oripalette', true)"
            />
          </li>
          <li>
            <MenuTitle
              title="SMS認証(500ptプレゼント)"
              image="/img/sms.png"
              @click="page('/sms')"
            />
          </li>
          <li>
            <MenuTitle
              v-if="referralCode != ''"
              class="referral_code"
              title="紹介コード"
              image="/img/point.png"
            >
              <span class="code">{{ referralCode }}</span>
              <div class="charge copy" @click="copyCode">
                <span>コピー</span>
              </div>
            </MenuTitle>
            <div v-if="copyResult != ''" class="copy_result">{{ copyResult }}</div>
          </li>
          <li class="menu-about">
            <div>オリパレットについて</div>
          </li>
          <!-- <li class="menu-text" @click="page('/terms-of-service', true)">利用規約</li> -->
          <li class="menu-text" @click="page('/terms/', true)">利用規約</li>
          <li class="menu-text" @click="toiawase">よくある質問/お問い合わせ</li>
          <li class="menu-text" @click="page('/policy/', true)">プライバシーポリシー</li>
          <li class="menu-text" @click="page('/notation/', true)">特定商取引法に基づく表記</li>
          <li class="menu-text" v-if="currentUser.is_login == '1'" @click="logout()">ログアウト</li>
        </ul>
      </div>
    </div>
    <div class="top_image" v-if="isTop && false">
      <img src="/img/top_banner.jpg" alt="オリパレットメインキャッチ">
    </div>
    <div class="banner_area">
      <div class="slick" v-if="isTop && bannerList && bannerMode == 1">
        <img v-for="(row, key) in bannerList.list" :key="key" :src="row.file_name" @click="clickBanner(row)">
      </div>
    </div>
    <OnceMore
      class="once-more"
      :isOpenResult="isOpenResult"
      :skip="true"
    ></OnceMore>
    <div
     v-if="showAddress"
     class="popup"
     @click="showAddress = false"
    >
      <AppendAddress
        class="header-mode"
        @handleSaveSuccess="addressSaveSuccess"></AppendAddress>
    </div>
    <CommonOverlay class="overlay" v-show="isOpenConfirm && currentUser.is_maintained">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isOpenConfirm = false">&times;</span>
        <div class="modal-title">
          <span>翌月のランク維持</span>
        </div>
        <div class="bay_area">
          <div class="modal-subtitle">
            <span>翌月の開始ランク</span>
          </div>
          <div class="use_num">
            <span>{{ rankNextMonthName }}</span>
          </div>
        </div>
        <div class="bay_area">
          <div class="modal-subtitle">
            <span>使用コイン</span>
          </div>
          <div class="use_num">
            <span>{{ rankCoin | comma }}C</span>
          </div>
          <div class="modal-subtitle">
            <span>保有コイン</span>
          </div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.coin | commaDecimal }}C</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.coin - rankCoin | commaDecimal }}C</div>
          </div>
        </div>
        <div v-if="currentUser.is_rank_maintained" class="modal-button-area">
          <BlackGradationButton class="bay-button" text="翌月のランクを維持する" @handleSquareBtnClick="buyRank" />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isOpenConp">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isOpenConp = false">&times;</span>
        <div class="modal-title">
          <span>翌月のランク維持完了</span>
        </div>
        <div class="modal-title">
          <span>翌月の開始ランクを{{ rankNextMonthName }}に維持しました。</span>
        </div>
        <div class="modal-button-area">
          <BlackGradationButton class="bay-button" text="閉じる" @handleSquareBtnClick="isOpenConp = false" />
        </div>
      </CommonModal>
    </CommonOverlay>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
// import SpMenu from '@/components/molecules/SpMenu.vue';
import OnceMore from '@/components/organisms/OnceMore.vue';
import AppendAddress from '@/components/organisms/AppendAddress.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import RankArea from '@/components/organisms/header/RankArea.vue';
import MenuTitle from '@/components/organisms/header/MenuTitle.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  name: 'CommonHeader',
  mixins: [t],

  props: {
    availablePoint: {
      type: String,
      default: '0',
    },
    // currentUser: {
    //   type: Object,
    //   default: () => { },
    // },
    isTop: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showMenu: false,
    showAddress: false,
    lastName: '',
    middleName: '',
    firstName: '',
    zipCode: '',
    prefectureName: '',
    shiku: '',
    address: '',
    building: '',
    referralCode: '',
    copyResult: '',
    isOpenResult: false,
    couponCodeError: '',
  }),

  created() {
    if (this.isTop) {
      this.$store.dispatch('banner/getBannerList');
    }
    this.$store.dispatch('user/setCurrentUserDetail');
    this.$store.dispatch('prefecture/setPrefectureList');
  },

  mounted() {
    if (this.isTop) {
      window.$(window).off('resize');
      window.$(window).on('resize', () => {
        this.checkBreakPoint();
      });
    }
  },

  components: {
    // Tokkyo,
    // MainLogo,
    // SpMenu,
    OnceMore,
    AppendAddress,
    // SquareButton,
    CommonOverlay,
    CommonModal,
    BlackGradationButton,
    RankArea,
    MenuTitle,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      bannerMode: 'banner/bannerMode',
      bannerList: 'banner/bannerList',
      currentUserDetail: 'user/currentUserDetail',
      logOutUserResult: 'user/logOutUserResult',
      resultCouponUseError: 'coupon/resultCouponUseError',
    }),
  },

  watch: {
    bannerList() {
      setTimeout(() => {
        this.checkBreakPoint();
      }, 100);
    },
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.middleName = newResult.middleName;
        this.firstName = newResult.firstName;
        this.zipCode = newResult.zipcode;
        this.prefectureName = newResult.pref_name;
        this.shiku = newResult.shiku;
        this.address = newResult.address;
        this.building = newResult.building;
        this.referralCode = newResult.referral_code;
      });
    },
    logOutUserResult(newResult) {
      if (newResult) {
        window.location.href = '/';
      }
    },
    resultCouponUseError(val) {
      this.couponCodeError = val;
      if (!val) {
        window.location.href = '/buy-point';
      }
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaDecimal(value) {
      return separateDecimalNumber(value);
    },
  },

  methods: {
    handleShopNameClick() {
      this.$emit('handleShopNameClick');
    },
    handlePointBoxClick() {
      this.$emit('handlePointBoxClick');
    },
    toggleMenu(mode) {
      this.showMenu = mode;
      this.copyResult = '';
    },
    page(url, isBlank = false) {
      if (isBlank) {
        window.open(url, '_blank');
      } else {
        this.$router.push(url);
      }
      this.showMenu = false;
    },
    checkBreakPoint() {
      window.$('.slick.slick-initialized').slick('unslick');
      if (window.$(window).width() <= 768) {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: true,
          centerMode: true,
          // centerPadding: '25%',
        });
      } else {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: false,
          variableWidth: true,
          centerMode: true,
          // centerPadding: '15%',
        });
        window.$('.slick').slick('slickGoTo', 0, false);
      }
    },
    toiawase() {
      window.open('https://oripalette.jp/user-guide/', '_blank');
    },
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
    shippingSkip() {
      this.isOpenResult = true;
      this.$store.dispatch('pack/setCurrentPack', { packId: this.$store.getters['pack/packId'] });
    },
    clickBanner(row) {
      if (row.link_url) {
        window.open(row.link_url, '_blank');
      }
    },
    showSaveAddress() {
      this.showAddress = true;
    },
    addressSaveSuccess() {
      this.showAddress = false;
      this.$store.dispatch('user/setCurrentUserDetail');
    },
    copyCode() {
      navigator.clipboard.writeText(this.referralCode)
        .then(() => {
          this.copyResult = 'コピーしました';
        })
        .catch((err) => {
          console.error('コピーに失敗しました: ', err);
        });
    },
    useCoupon() {
      this.$store.dispatch('coupon/useCoupon', { couponCode: this.couponCode });
    },
  },

};
</script>

<style lang="scss" scoped>
.header_block {
  padding-top: 100px;
}
.header_base {
  position: fixed;
  top: 0;
  z-index: 10;
}

.header {
  background-color: #f3f3f3;
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  // border-bottom: solid 1px $black;
  // &::after {
  //   content: '';
  //   display: block;
  //   clear: both;
  //   width: 100%;
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   border-bottom: solid 3px $gray;
  // }

  .sp-menu {
    width: 120px;
  }

}
.login_area {
  display: flex;
  justify-content: flex-end;

  .login {
    display: flex;
    justify-content: center;
    align-items: center;

    .login_box {
      padding: 6px 20px;
      border-radius: 50px;
      border: solid 2px $black;
      box-shadow: 0 1px 0px $black;
      font-size: 14px;
      a {
        color: $black !important;
        font-weight: bold;
      }
    }

    .point_icon {
      width: 15px;
      z-index: 1;
    }

    .point_block {
      // background-color: $black;
      color: $black;
      // height: 30px;
      z-index: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: bold;
      cursor: pointer;
      margin-left: 8px;
      font-size: 20px;
      position: relative;
    }
    // 右下にプラスマーク
    .plus {
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: #b6bbc7;
      border-radius: 50%;
      right: -15px;
      bottom: -2px;
      z-index: 1;
    }

    .plus:before,
    .plus:after {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .plus:before {
      content: '';
      position: absolute;
      width: 8px;  /* 横線の長さ */
      height: 2px; /* 横線の太さ */
      background-color: black;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -55%);
      z-index: 2;
    }

    .plus:after {
      content: '';
      position: absolute;
      width: 2px;  /* 縦線の太さ */
      height: 8px; /* 縦線の長さ */
      background-color: black;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
    .account {
      width: 20px;
      margin-left: 40px;
      cursor: pointer;
    }
  }
  .coin {
    margin-left: 10px;
  }
  .rank_icon_sp {
    width: 32px;
    display: none;
      @media screen and  (max-width: $tabletWidth) {
        display: inline;
      }
  }
  .rank_icon {
    width: 52px;
    margin-right: 10px;
    @media screen and  (max-width: $tabletWidth) {
      display: none;
    }
  }
  .rank_icon {
    margin-top: 0px;
    text-align: center;
    img {
      width: 42px;
    }
  }
}

.menu_area {
  display: flex;
  position: fixed;
  background: $white;
  color: $black;
  z-index: 10;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;

  .user_area {
    margin-bottom: 20px;
    font-weight: bold;

    .user_name {
      padding: 0;
    }
    .point_area {
      background-color: $white;
      border-radius: 12px;
      color: $black;
      text-align: right;
      padding: 5px 5px 5px 0;
      position: relative;
      border: solid 1px $black;
      margin-top: 20px;
    }
    .img {
      width: 36px;
      z-index: 1;
    }
  }

  div.menu {
    cursor: pointer;
    transition: .4s;
    border-left: solid 1px $black;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }

  .logout {
    width: 100%;
    border-left: solid 1px $black;
    font-weight: bold;

    span {
      border: solid 1px $black;
      border-radius: 24px;
      padding: 5px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;

      img {
        margin-left: 5px;
        width: 26px;
      }
    }
  }
}

.logo {
  cursor: pointer;
  width: 196px;
}

.movie_area {
  background-color: #fff;
  text-align: center;

  video {
    max-width: 800px;
    width: 100%;
  }
}

.banner_area {
  display: flex;
  justify-content: center;
}
.slick {
  width: 350px;
  .slick-track {
    img {
      // margin: 10px 2px 0 2px !important;
      border-radius: 10px;
      width: 350px !important;
    }
    ul {
      padding: 0 !important;
    }
  }
}

.pc {
  display: block;
}

.sp {
  display: none !important;
}

.copy_result {
  text-align: center;
}

.top_image {
  text-align: center;
  margin-bottom: 10px;
  img {
    border-radius: 10px;
  }
  @media screen and (max-width: $tabletWidth) {
    text-align: center;
    img {
      width: 100%;
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .header_block {
    padding-top: 60px;
  }
  .header_base {
    padding-top: 72px;
  }

  .header {
    padding: 10px;
    justify-content: space-between;

    .sp-menu {
      width: 100px;
    }

    .logo {
      width: 120px;
    }

    .login_area {
      // width: 100px;
      flex-direction: column;

      .login {
        .login_box {
          padding: 5px 10px;
          font-weight: bold;
        }

        .point_icon {
          width: 15px;
        }

        .point_block {
          height: 20px;
          font-size: 14px;
          text-align: right;
          display: block;
        }
        .account {
          margin-left: 25px;
        }
      }
      .coin {
        margin: 5px 0 0 0;
      }
    }
  }

  .menu_area {
    position: fixed;
    flex-direction: column;
    justify-content: flex-start;
    width: auto;
    padding: 15px 0 15px 0;
    height: calc(100vh - 73px);
    min-width: 200px;

    div.menu {
      padding: 10px 0;
      border-left: none;
      border-top: solid 1px $black;

      &:hover {
        text-decoration: auto;
      }

      &:last-child {
        border-bottom: solid 1px $black;
      }
    }

    .logout {
      border-left: none;
      border-top: solid 1px $black;

      span {
        margin: 40px auto 0 auto;
        max-width: 160px;
      }
    }
  }
  .tokkyo_logo {
    text-align: right;
    padding-right: 10px;
  }

  .pc {
    display: none !important;
  }

  .sp {
    display: block !important;
  }
}

.menu-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 1000;
}
.menu {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 400px;
  background: white;
  transform: translateX(105%);
  transition: transform 0.3s ease;
  z-index: 1001;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  color: #353e59;
  h2 {
    padding: 20px 25px;
    border-bottom: 5px solid #b5bac6;
    font-size: 20px;
  }
  // 初期化
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    li {
      padding: 10px 25px;
      color: #353e59;
      .menu-comment {
        font-size: 10px;
      }
      .menu-point {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        padding: 0 0 0 25px;
        @media (max-width: $tabletWidth) {
          padding: 0;
        }
        input {
          border: solid 1px #e7e6e6;
          border-radius: 5px;
          padding: 5px 5px;
          max-width: 200px;
          &::placeholder {
            font-size: 11px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .button-append {
          background-color: #af095c;
          text-align: center;
          min-width: 62px;
          color: #fff;
          padding: 4px 15px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
      .error-message {
        color: #ff0e0e;
        font-size: 12px;
        white-space: pre;
        margin-bottom: 5px;
      }
      .manu-rank {
        display: flex;
        // justify-content: space-between;
        justify-content: center;
        margin-top: 5px;
        padding: 0 28px;
        img {
          margin-top: 5px;
          width: 42px;
        }
        .rank_icon {
          @media screen and  (max-width: $tabletWidth) {
            display: none;
          }
        }
        .rank_icon_sp {
          width: 32px;
          display: none;
          @media screen and  (max-width: $tabletWidth) {
            display: inline;
          }
        }
        .next-rank {
          margin-left: 20px;
          display: flex;
          align-items: center;
        }
      }
      .rank-maintained {
        .square-button{
          margin: auto;
          width: 50%;
        }
      }
      .charge {
        background-color: #353e59;
        color: $white;
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        padding: 4px 8px;
        cursor: pointer;
        span {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
        .charge_plus {
          content: '';
          position: relative;
          width: 20px;
          height: 20px;
          background-color: $white;
          color: #353e59;
          border-radius: 50%;
          z-index: 1;
          margin-right: 5px;
        }

        .charge_plus:before,
        .charge_plus:after {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .charge_plus:before {
          content: '';
          position: absolute;
          width: 8px;  /* 横線の長さ */
          height: 2px; /* 横線の太さ */
          background-color: black;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }

        .charge_plus:after {
          content: '';
          position: absolute;
          width: 2px;  /* 縦線の太さ */
          height: 8px; /* 縦線の長さ */
          background-color: black;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }
      }
      .login_area .login .point_block:after {
        content: '';
        display: none;
      }
      .manu-address {
        padding: 5px 10px;
        margin: 5px 10px;
        border: 1px solid #b5bac6;
        border-radius: 10px;
        .name {
          border-bottom: 1px solid #f3f3f3;
          padding: 5px 5px;
          font-weight: bold;
        }
        .post-address {
          padding: 5px 0 0 5px;
          font-size: 12px;
          font-weight: bold;
          .add_address {
            margin: auto;
          }
        }
        .address {
          padding-left: 5px;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .buy-product-history {
        cursor: pointer;
        margin-top: -10px;
      }
      .referral_code {
        margin-top: -10px;
        .code {
          margin-left: 10px;
        }
        .copy {
          cursor: pointer;
          margin-left: 10px;
          width: 80px!important;
        }
      }
    }
    .menu-about {
      padding: 5px 30px;
      background-color: #b5bac6;
      color: $white;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .menu-text {
      color: #353e59;
      font-weight: bold;
      cursor: pointer;
      padding: 8px 30px;
    }
  }
}
.menu.active {
  transform: translateX(0);
  overflow-y: auto;
}
.menu-overlay.active {
  display: block;
}
.close-button {
  position: absolute;
  top: 3px;
  right: 10px;
  font-size: 36px;
  cursor: pointer;
}
.return-list {
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  font-size: 19px;
  padding-left: 10px;
  .arrow {
    margin-right: 5px;
  }
}
.get-list {
  font-weight: 700;
  margin-top: 8px;
  font-size: 20px;
  padding-left: 10px;
}
.get-skip {
  font-weight: 700;
  margin-top: 8px;
  margin-right: 50px;
  font-size: 18px;
  padding-right: 10px;
  cursor: pointer;
  color: #b5bac6;
  .arrow {
    margin-left: 5px;
  }
}
.get-skip:hover {
  color: #000;
}
.once-more {
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup {
  background-color: rgba(63, 72, 97, 0.9);
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
  z-index: 10;

  .modal {
    padding: 40px 28px;
    font-family: $notoSans;
    color: #000;
    text-align: center;
    width: 586px;

    .modal-title {
      font-size: 24px;
      font-weight: bold;
    }

    .text {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }

    .modal-button-area {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;

      .square-button {
        width: 120px;
        height: 50px;

        &+.square-button {
          margin-left: 20px;
        }
      }
    }
  }
}
.pack-confirm {
  background-color: #fff;
  color: #000;
  position: absolute;
  height: auto;

  .close {
    /* 閉じるボタンを右上に表示 */
    position: absolute;
    top: 10px;
    right: 10px;
    /* 閉じるボタンの大きさ */
    font-size: 24px;
    /* 閉じるボタンのカーソル */
    cursor: pointer;
  }

  .bay_area {
    background-color: $mainGray;
    padding: 20px 0;
    border-radius: 9px;
    & + .bay_area {
      margin-top: 10px;
    }
  }

  .modal-subtitle {
    width: 50%;
    margin: auto;
    background-color: #000;
    color: #fff;
  }

  .use_num {
    font-size: 40px;
    font-weight: bold;
    color: #000;
  }

  .use-point {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    width: 50%;
    margin: auto;
  }

  .bay-button {
    width: 100%;
    height: 52px;
  }
}
@media (max-width: $tabletWidth) {
  .menu {
    width: 100%;
  }
  .get-list {
    font-size: 14px;
  }
  .get-skip {
    margin-right: 0;
    font-size: 14px
  }
  .get-list-mobile {
    display: none !important;
  }
  .overlay {
    .modal {
      width: 80%;
    }
  }
  .pack-confirm {
    .modal-subtitle {
      font-size: 12px;
    }

    .use_num {
      font-size: 20px;
    }

    .bay-button {
      height: 45px;
    }
  }
}
</style>
<style lang="scss">
.slick {
  .slick-track {
    width: 10000px !important;
  }
  .slick-list {
    padding: 0 !important;
  }
  .slick-dots {
    padding: 0 !important;
  }
  .slick-dots {
    li {
      button {
        &:before {
          color: #ef5656;
        }
      }
      &.slick-active {
        button {
          &:before {
            color: #ef5656;
          }
        }
      }
    }
  }
}
</style>
